var _defs, _path, _path2, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStampNetherlands(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2350.9 3352",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: -0.01463,
    y: -0.010171,
    width: 1.0293,
    height: 1.0203,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.923148
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m109.72 3309.7c-0.9891-39.592-35.333-76.244-71.442-76.244h-4.84v-83h3.5422c92.315 0 95.886-150.89 3.7559-158.68l-7.2981-0.6169v-65.346l8.8309-1.1757c88.423-11.773 89.723-143.65 1.5575-157.99l-10.385-1.6896v-73.5h3.5422c92.358 0 95.93-150.88 3.7559-158.68l-7.2981-0.6169v-82.706h3.5422c32.139 0 63.994-28.277 71.534-63.5 9.8209-45.882-27.203-95.5-71.259-95.5h-3.8163v-82.724l6.75-0.6838c91.162-9.2343 91.652-150.57 0.5481-158.27l-7.2981-0.6169v-82.412l7.385-0.6243c90.231-7.6273 90.222-150.71-0.011-158.34l-7.3744-0.6234v-73.456l3.125-0.625c1.7187-0.3437 4.3367-0.625 5.8176-0.625 15.126 0 39.423-14.074 50.863-29.463 36.836-49.549 8.7414-120.77-50.766-128.69l-9.0395-1.2035v-81.406l2.25-0.603c1.2375-0.3317 3.7962-0.6091 5.6861-0.6166 16.181-0.064 39.8-13.527 51.767-29.507 37.492-50.063 7.6121-122.91-52.954-129.09l-6.75-0.6896v-73.364l8.8309-1.1757c89.495-11.916 88.546-150.57-1.0809-157.85l-7.75-0.6295v-82.428l6.3299-0.6485c92.073-9.4334 90.764-158.63-1.3948-158.63h-4.938v-75h5.34c91.384 0 92.718-150.07 1.41-158.65l-6.75-0.63475v-65.42l7.25-0.61685c91.281-7.7664 88.716-158.68-2.6974-158.68h-4.5526v-65.58l10.298-1.6335c88.404-14.08 86.174-151.5-2.557-157.6l-7.7633-0.53355 0.5266-66.212 7.5-0.62506c32.939-2.7451 62.331-31.558 67.525-66.194l0.7019-4.6808h94.542l0.6629 5.3058c10.95 87.639 135.92 86.352 151.01-1.5558l0.644-3.75h80.52l1.2244 7.25c14.002 82.909 130.79 84.897 149.36 2.5429l2.2085-9.7929h72.598v2.34c0 9.6788 8.5936 29.835 17.328 40.644 40.863 50.564 120.38 29.68 133.36-35.025l1.5963-7.9591h72.326l1.2244 7.25c14.148 83.778 133.05 84.479 149.82 0.8843l1.6315-8.1343h72.308l1.2218 7.1251c14.55 84.85 135.48 84.23 150.28-0.76985l1.1067-6.3553h72.794v2.3117c0 14.445 13.656 39.571 27.915 51.362 45.258 37.423 112.93 11.535 123.15-47.106l1.1437-6.5676h80.344l1.7914 8.75c13.295 64.937 94.403 84.776 134.14 32.81 8.2025-10.728 16.523-30.729 16.523-39.72 0-1.7487 1.6019-1.84 32.275-1.84h32.275l1.7191 8.3518c15.164 73.667 111.24 86.001 143.27 18.392 3.2523-6.8649 7.4638-20.917 7.4638-24.904 0-1.7563 1.837-1.84 40.386-1.84h40.386l0.7019 4.6808c13.122 87.501 137.93 87.501 151.05 0l0.7019-4.6808 64.272 2.04e-4 0.1774 10.25c0.7219 41.71 34.737 77.65 73.573 77.735l6.75 0.0148v33.031c0 25.576-0.2821 33.109-1.25 33.373-0.6875 0.18811-4.175 0.8824-7.75 1.5429-80.196 14.816-79.773 140.34 0.5257 155.91l8.4677 1.6422v74.41l-3.75 0.64403c-53.208 9.1381-81.66 65.77-57.75 114.95 11.576 23.808 29.363 36.816 58.75 42.963l2.75 0.57524v65.872l-3.75 0.59531c-85.611 13.591-87.911 141.56-2.8351 157.7l6.5851 1.2492v74.338l-6.6022 1.1497c-83.37 14.518-82.649 147.04 0.8522 156.65l5.75 0.6616v83.536l-6.75 1.1726c-83.357 14.481-82.634 144.77 0.8708 156.79l5.3792 0.7739 0.5236 75.026-6.8291 1.0753c-52.942 8.3364-80.993 76.343-50.392 122.17 13.163 19.714 37.111 35.198 54.439 35.198h2.781l-0.2609 41.694-0.261 41.694-7.5 1.3684c-51.829 9.4559-78.704 73.815-50.328 120.53 11.652 19.182 38.186 36.718 55.558 36.718h2.7701v74.91l-3.75 0.6161c-88.653 14.565-87.852 141.13 1 157.99l2.75 0.5217v82.872l-3.75 0.6161c-89.183 14.652-87.988 140.61 1.5 158.07l2.25 0.4391v82.924l-2.75 0.5217c-40.865 7.7524-67.25 38.754-67.25 79.016 0 40.3 26.347 71.257 67.25 79.016l2.75 0.5217v82.924l-2.75 0.5217c-88.901 16.865-89.702 143.42-1 157.99l3.75 0.6161v74.41l-8.4677 1.6422c-80.17 15.548-80.594 141.31-0.5257 155.92 3.575 0.6523 7.0625 1.34 7.75 1.5281 0.9678 0.2648 1.25 7.7883 1.25 33.328v32.986l-3.75 0.6161c-86.557 14.22-88.16 140.47-2 157.48l5.75 1.1355v73.57l-8.25 0.6847c-36.224 3.0064-62.939 27.718-71.193 65.853l-0.5952 2.75h-64.924l-0.5952-2.75c-8.6786-40.097-37.999-65.588-75.443-65.588-37.472 0-66.758 25.46-75.443 65.588l-0.5952 2.75h-40.512c-31.573 0-40.583-0.2758-40.832-1.25-0.1758-0.6875-1.0699-4.4-1.9868-8.25-18.498-77.675-130.95-77.294-147.63 0.5-0.6483 3.025-1.3948 6.2875-1.6588 7.25-0.6214 2.2652-65.151 2.7561-65.728 0.5-0.1758-0.6875-1.0699-4.4-1.9868-8.25-19.507-81.91-130.98-76.863-149.07 6.75l-0.5952 2.75h-40.512c-31.547 0-40.594-0.2766-40.88-1.25-0.202-0.6875-1.0832-4.4-1.9582-8.25-16.419-72.239-116.12-79.512-143.92-10.5-2.3703 5.8827-3.1087 8.3769-5.1071 17.25l-0.6193 2.75h-36.512c-28.347 0-36.594-0.2795-36.88-1.25-0.202-0.6875-1.094-4.4-1.9823-8.25-18.36-79.578-132.17-76.705-148.56 3.75l-1.1713 5.75h-36.46c-28.306 0-36.543-0.2796-36.828-1.25-0.202-0.6875-1.0915-4.3747-1.9768-8.1939-18.104-78.1-134.98-76.566-148.1 1.9439-1.3938 8.3435 2.7505 7.5559-38.214 7.2622l-36.578-0.2622-1.8149-7.6926c-19.11-80.998-132.04-79.136-148.85 2.4548l-1.1867 5.7623-73.152-0.5245-1.8149-7.6926c-19.112-81.007-132.04-79.154-148.84 2.4426l-1.1841 5.75h-81.402l-1.2337-6.5037c-15.555-81.999-132.26-81.41-149.18 0.7537l-1.1841 5.75-94.358-0.02-0.2185-8.7446zm2104.7-1645.7v-1529.5h-2068v3074h2068z",
    filter: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m103.72 3303.7c-0.9891-39.592-35.333-76.244-71.442-76.244h-4.84v-83h3.5422c92.315 0 95.886-150.89 3.7559-158.68l-7.2981-0.6169v-65.346l8.8309-1.1757c88.423-11.773 89.723-143.65 1.5575-157.99l-10.385-1.6896v-73.5h3.5422c92.358 0 95.93-150.88 3.7559-158.68l-7.2981-0.6169v-82.706h3.5422c32.139 0 63.994-28.277 71.534-63.5 9.8209-45.882-27.203-95.5-71.259-95.5h-3.8163v-82.724l6.75-0.6838c91.163-9.2343 91.652-150.57 0.5481-158.27l-7.2981-0.6169v-82.412l7.385-0.6243c90.231-7.6273 90.222-150.71-0.011-158.34l-7.3744-0.6234v-73.456l3.125-0.625c1.7188-0.3437 4.3367-0.625 5.8176-0.625 15.126 0 39.423-14.074 50.863-29.463 36.837-49.549 8.7414-120.77-50.766-128.69l-9.0395-1.2035v-81.406l2.25-0.603c1.2375-0.3317 3.7963-0.6091 5.6861-0.6166 16.181-0.064 39.8-13.527 51.767-29.507 37.492-50.063 7.6121-122.91-52.954-129.09l-6.75-0.6896v-73.364l8.8309-1.1757c89.495-11.916 88.546-150.57-1.0809-157.85l-7.75-0.6295v-82.428l6.3299-0.6485c92.073-9.4334 90.764-158.63-1.3948-158.63h-4.938v-75h5.34c91.384 0 92.718-150.07 1.41-158.65l-6.75-0.63475v-65.42l7.25-0.61685c91.281-7.7664 88.716-158.68-2.6974-158.68h-4.5526v-65.58l10.298-1.6335c88.404-14.08 86.174-151.5-2.557-157.6l-7.7633-0.53355 0.5266-66.212 7.5-0.62505c32.939-2.7451 62.331-31.558 67.525-66.194l0.7019-4.6808h94.542l0.6629 5.3058c10.95 87.639 135.92 86.352 151.01-1.5558l0.644-3.75h80.52l1.2244 7.25c14.002 82.909 130.79 84.897 149.36 2.5429l2.2085-9.7929h72.598v2.34c0 9.6788 8.5936 29.835 17.328 40.644 40.863 50.564 120.38 29.68 133.36-35.025l1.5963-7.9591h72.326l1.2244 7.25c14.148 83.778 133.05 84.479 149.82 0.8843l1.6315-8.1343h72.308l1.2218 7.1251c14.55 84.85 135.48 84.23 150.28-0.76985l1.1067-6.3553h72.794v2.3117c0 14.445 13.656 39.571 27.915 51.362 45.258 37.423 112.93 11.535 123.15-47.106l1.1437-6.5676h80.344l1.7914 8.75c13.295 64.937 94.403 84.776 134.14 32.81 8.2025-10.728 16.523-30.729 16.523-39.72 0-1.7487 1.6019-1.84 32.275-1.84h32.275l1.7191 8.3518c15.164 73.667 111.24 86.001 143.27 18.392 3.2523-6.8649 7.4638-20.917 7.4638-24.904 0-1.7563 1.837-1.84 40.386-1.84h40.386l0.7019 4.6808c13.122 87.501 137.93 87.501 151.05 0l0.7019-4.6808 64.272 2.04e-4 0.1774 10.25c0.7219 41.71 34.737 77.65 73.573 77.735l6.75 0.0148v33.031c0 25.576-0.2821 33.109-1.25 33.373-0.6875 0.18811-4.175 0.8824-7.75 1.5429-80.196 14.816-79.773 140.34 0.5257 155.91l8.4677 1.6422v74.41l-3.75 0.64403c-53.208 9.1381-81.66 65.77-57.75 114.95 11.576 23.808 29.363 36.816 58.75 42.963l2.75 0.57524v65.872l-3.75 0.59531c-85.611 13.591-87.911 141.56-2.8351 157.7l6.5851 1.2492v74.338l-6.6022 1.1497c-83.37 14.518-82.649 147.04 0.8522 156.65l5.75 0.6616v83.536l-6.75 1.1726c-83.357 14.481-82.634 144.77 0.8708 156.79l5.3792 0.7739 0.5236 75.026-6.8291 1.0753c-52.942 8.3364-80.993 76.343-50.392 122.17 13.163 19.714 37.111 35.198 54.439 35.198h2.781l-0.2609 41.694-0.261 41.694-7.5 1.3684c-51.829 9.4559-78.704 73.815-50.328 120.53 11.652 19.182 38.186 36.718 55.558 36.718h2.7701v74.91l-3.75 0.6161c-88.653 14.565-87.852 141.13 1 157.99l2.75 0.5217v82.872l-3.75 0.6161c-89.183 14.652-87.988 140.61 1.5 158.07l2.25 0.4391v82.924l-2.75 0.5217c-40.865 7.7524-67.25 38.754-67.25 79.016 0 40.3 26.347 71.257 67.25 79.016l2.75 0.5217v82.924l-2.75 0.5217c-88.901 16.865-89.702 143.42-1 157.99l3.75 0.6161v74.41l-8.4677 1.6422c-80.17 15.548-80.594 141.31-0.5257 155.92 3.575 0.6523 7.0625 1.34 7.75 1.5281 0.9678 0.2648 1.25 7.7883 1.25 33.328v32.986l-3.75 0.6161c-86.557 14.22-88.16 140.47-2 157.48l5.75 1.1355v73.57l-8.25 0.6847c-36.224 3.0064-62.939 27.718-71.193 65.853l-0.5952 2.75h-64.924l-0.5952-2.75c-8.6786-40.097-37.999-65.588-75.443-65.588-37.472 0-66.758 25.46-75.443 65.588l-0.5952 2.75h-40.512c-31.573 0-40.583-0.2758-40.832-1.25-0.1758-0.6875-1.0699-4.4-1.9868-8.25-18.498-77.675-130.95-77.294-147.63 0.5-0.6483 3.025-1.3948 6.2875-1.6588 7.25-0.6214 2.2652-65.151 2.7561-65.728 0.5-0.1758-0.6875-1.0699-4.4-1.9868-8.25-19.507-81.91-130.98-76.863-149.07 6.75l-0.5952 2.75h-40.512c-31.547 0-40.594-0.2766-40.88-1.25-0.202-0.6875-1.0832-4.4-1.9582-8.25-16.419-72.239-116.12-79.512-143.92-10.5-2.3703 5.8827-3.1087 8.3769-5.1071 17.25l-0.6193 2.75h-36.512c-28.347 0-36.594-0.2795-36.88-1.25-0.202-0.6875-1.094-4.4-1.9823-8.25-18.36-79.578-132.17-76.705-148.56 3.75l-1.1713 5.75h-36.46c-28.306 0-36.543-0.2796-36.828-1.25-0.202-0.6875-1.0915-4.3747-1.9768-8.1939-18.104-78.1-134.98-76.566-148.1 1.9439-1.3938 8.3435 2.7505 7.5559-38.214 7.2622l-36.578-0.2622-1.8149-7.6926c-19.11-80.998-132.04-79.136-148.85 2.4548l-1.1867 5.7623-73.152-0.5245-1.8149-7.6926c-19.112-81.007-132.04-79.154-148.84 2.4426l-1.1841 5.75h-81.402l-1.2337-6.5037c-15.555-81.999-132.26-81.41-149.18 0.7537l-1.1841 5.75-94.358-0.02-0.2185-8.7446z",
    fill: "#f9f9f9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 177.31,
    y: 169.47,
    width: 1984.3,
    height: 3001.1,
    fill: "#d1e2bd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#83b04d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1178.3 1228.7a146.53 264.79 0 0 0-146.78 263.87l146.53 0.9238h146.53a146.53 264.79 0 0 0-146.27-264.79zm-0.4746 19.967a127.03 232.03 0 0 1 126.84 232.03h-127.03l-127.04-0.705a127.03 232.03 0 0 1 127.23-231.32z",
    stroke: "#d1e2bd",
    strokeMiterlimit: 3.9101,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1177.9 1240.6c-35.39 0.6381-66.447 24.15-85.205 52.856-35.441 51.708-47.499 115.26-50.793 176.81-0.6917 11.142 11.472 20.747 22.154 17.545 81.633 1.0721 163.28 0.6351 244.91 1.0449 8.3248-27.352-0.2601-55.912-2.8555-83.398-9.2059-51.892-29.77-104.05-68.965-140.65-16.379-14.14-37.235-24.41-59.248-24.211z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeMiterlimit: 3.9101
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#d1e2bd",
    strokeWidth: 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "m741.73 2204.1c3.9592 4.4008-192.19-91.041-192.19-91.041l-0.93742-25.296 193.73 95.873-0.60065 20.461z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.58 2139-13.115-5.9969 0.78772 100.64 11.973 5.8426 0.35372-100.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m668.14 2169.7-13.115-5.9969 0.78772 100.64 11.973 5.8426 0.35373-100.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m800.27 1406.9c-13.236 35.01-22.018 51.59-30.353 78.07-3.0194 9.5917-3.9632 20.669 6.6151 72.159l221.17-66.267s0.74538-56.626 19.642-120.78c18.897-64.159 48.914-132.38 128.53-166.81l-34.516 16.035-120.89 57.289c-26.911 36.626-29.973 52.921-71.414 98.15l45.475-86.138-29.197 15.065c-104.8 46.206-81.427 87.958-117.7 131.4 7.8758-34.238 7.1244-58.404 34.609-92.379 0 0-73.778 29.333-105.19 106.65-22.932 56.443-16.7 123.23-16.7 123.23l31.48-10.415c-11.177-50.768-9.1218-63.044 11.985-111.36"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1013.3 1531.7s-13.649 314.02-29.433 448.15c-19.898 169.11-35.08 220.92-35.08 220.92l28.483-4.1043c17.303-110.92 29.127-154.96 45.121-384.45 20.222-290.17 12.31-278.8 12.31-278.8l-21.402-1.714z",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1227.1 1522.1s25.122 318.81 55.839 456.07c37.92 169.43 61.8 226.84 61.8 226.84l-37.072-2.3702c-22.672-111.98-45.664-161.46-76.677-394.43-39.206-294.55-24.526-283.45-24.526-283.45l20.632-2.6379z",
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 3.9101
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1178.5 1525.6s10.886 220.84 38.086 370.37c39.142 215.2 39.99 214.33 68.552 308.33l-295.15-1.8801s30.467-69.562 47.605-370.37 19.042-304.57 17.138-304.57l123.77-1.8801z",
    stroke: "#d1e2bd",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 15
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1007.4,
    y: 2147.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1073.3,
    y: 2147.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1051.3,
    y: 2147.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1029.3,
    y: 2147.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1139.3,
    y: 2147.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.3,
    y: 2147.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1095.3,
    y: 2147.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1205.2,
    y: 2147.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1183.2,
    y: 2147.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1161.3,
    y: 2147.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1249.2,
    y: 2147.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1227.2,
    y: 2147.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1016.8,
    y: 2111.2,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1082.7,
    y: 2111.2,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1060.8,
    y: 2111.2,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1038.8,
    y: 2111.2,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1148.7,
    y: 2111.2,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1126.7,
    y: 2111.2,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1104.7,
    y: 2111.2,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1214.6,
    y: 2111.2,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1192.7,
    y: 2111.2,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170.7,
    y: 2111.2,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1236.6,
    y: 2111.2,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1026.9,
    y: 2081.9,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1092.8,
    y: 2081.9,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1070.9,
    y: 2081.9,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.9,
    y: 2081.9,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1158.8,
    y: 2081.9,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1136.8,
    y: 2081.9,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1114.8,
    y: 2081.9,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224.8,
    y: 2081.9,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1202.8,
    y: 2081.9,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.8,
    y: 2081.9,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1020.8,
    y: 2044.7,
    width: 9.3691,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080.1,
    y: 2044.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1058.1,
    y: 2044.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1036.1,
    y: 2044.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1146,
    y: 2044.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1124,
    y: 2044.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1102,
    y: 2044.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1212,
    y: 2044.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1190,
    y: 2044.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1168,
    y: 2044.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1234,
    y: 2044.7,
    width: 9.3691,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1023.5,
    y: 2006.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1089.5,
    y: 2006.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1067.5,
    y: 2006.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1045.5,
    y: 2006.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.4,
    y: 2006.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1133.4,
    y: 2006.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1111.5,
    y: 2006.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1221.4,
    y: 2006.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1199.4,
    y: 2006.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1177.4,
    y: 2006.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1034.3,
    y: 1969.6,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1100.2,
    y: 1969.6,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.2,
    y: 1969.6,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1056.3,
    y: 1969.6,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1166.2,
    y: 1969.6,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1144.2,
    y: 1969.6,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1122.2,
    y: 1969.6,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.3,
    y: 1936.3,
    width: 8.0228,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1210.2,
    y: 1969.6,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1188.2,
    y: 1969.6,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1086.1,
    y: 1935.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1064.1,
    y: 1935.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1042.1,
    y: 1935.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152.1,
    y: 1935.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1130.1,
    y: 1935.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1108.1,
    y: 1935.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1196,
    y: 1935.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174,
    y: 1935.7,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1035,
    y: 1901.1,
    width: 12.062,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1096.9,
    y: 1901.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1074.9,
    y: 1901.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1052.9,
    y: 1901.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1162.8,
    y: 1901.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1140.8,
    y: 1901.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1118.8,
    y: 1901.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1206.8,
    y: 1901.1,
    width: 12.062,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1184.8,
    y: 1901.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1028.8,
    y: 1933.7,
    width: 8.0228,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1013.4,
    y: 2082.6,
    width: 8.0228,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1244.3,
    y: 2081.9,
    width: 8.0228,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1201.3,
    y: 1832.7,
    width: 8.0228,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1084.1,
    y: 1866.6,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1062.1,
    y: 1866.6,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.1,
    y: 1866.6,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1150,
    y: 1866.6,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1128,
    y: 1866.6,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1106.1,
    y: 1866.6,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1194,
    y: 1866.6,
    width: 12.062,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1172,
    y: 1866.6,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1071.7,
    y: 1832.7,
    width: 16.494,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1049.2,
    y: 1832.7,
    width: 16.494,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1036.7,
    y: 1832.7,
    width: 6.3949,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1139.2,
    y: 1832.7,
    width: 16.494,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1116.7,
    y: 1832.7,
    width: 16.494,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1094.2,
    y: 1832.7,
    width: 16.494,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1184.3,
    y: 1832.7,
    width: 12.356,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1161.8,
    y: 1832.7,
    width: 16.494,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1081.4,
    y: 1798.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1059.4,
    y: 1798.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1037.4,
    y: 1798.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1147.4,
    y: 1798.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1125.4,
    y: 1798.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1103.4,
    y: 1798.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1191.3,
    y: 1798.1,
    width: 12.062,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1169.3,
    y: 1798.1,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1091.1,
    y: 1761.4,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1069,
    y: 1761.4,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1047.1,
    y: 1761.4,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1157,
    y: 1761.4,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1135,
    y: 1761.4,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1113,
    y: 1761.4,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1179,
    y: 1761.4,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1079.2,
    y: 1721.8,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1057.2,
    y: 1721.8,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1044.8,
    y: 1721.8,
    width: 6.4462,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1145.1,
    y: 1721.8,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1123.1,
    y: 1721.8,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1101.1,
    y: 1721.8,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1189.1,
    y: 1721.8,
    width: 4.635,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1167.1,
    y: 1721.8,
    width: 16.101,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1089.5,
    y: 1687.4,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1068.3,
    y: 1687.4,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1047.1,
    y: 1687.4,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1153.2,
    y: 1687.4,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1131.9,
    y: 1687.4,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1110.7,
    y: 1687.4,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174.3,
    y: 1687.4,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1099.9,
    y: 1649.2,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.7,
    y: 1649.2,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1057.5,
    y: 1649.2,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1163.5,
    y: 1649.2,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1142.3,
    y: 1649.2,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1121.1,
    y: 1649.2,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1089.5,
    y: 1613.3,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1068.3,
    y: 1613.3,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1050.8,
    y: 1613.3,
    width: 11.822,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1153.2,
    y: 1613.3,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1131.9,
    y: 1613.3,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1110.7,
    y: 1613.3,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174.3,
    y: 1613.3,
    width: 10.337,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1099.2,
    y: 1576.7,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1077.9,
    y: 1576.7,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1056.7,
    y: 1576.7,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1162.8,
    y: 1576.7,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1141.6,
    y: 1576.7,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120.4,
    y: 1576.7,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1107.3,
    y: 1539.2,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1086.1,
    y: 1539.2,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1064.9,
    y: 1539.2,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1149.8,
    y: 1539.2,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1128.5,
    y: 1539.2,
    width: 15.536,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1169.1,
    y: 1538.5,
    width: 7.3661,
    height: 48.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1055.5,
    y: 1537.8,
    width: 3.6522,
    height: 48.07
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1104 1948.1h42.014l1.0504 108.89h-50.418l7.3528-108.89z",
    fillRule: "evenodd",
    stroke: "#d1e2bd",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1365.9 2205.7s-35.705-46.078-84.36-350.57c-30.825-192.91-32.691-330.43-32.691-330.43l97.526 10.701s22.936 272.19 91.094 453.88c61.909 165.03 84.749 229.08 84.749 229.08-36.005 2.5076-109.51-10.424-156.31-12.662z",
    stroke: "#d1e2bd",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99646 -.084037 .33766 .94127 0 0)",
    x: -625.7,
    y: 2210.1,
    width: 25.071,
    height: 75.636,
    strokeWidth: 15.728
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99646 -.084037 .33766 .94127 0 0)",
    x: -744.51,
    y: 2211.7,
    width: 25.071,
    height: 75.636,
    strokeWidth: 15.728
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99643 -.084472 .33611 .94182 0 0)",
    x: -719.96,
    y: 2209.2,
    width: 24.942,
    height: 75.591,
    strokeWidth: 15.724
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99646 -.084037 .33766 .94127 0 0)",
    x: -687.54,
    y: 2211.3,
    width: 25.071,
    height: 75.636,
    strokeWidth: 15.728
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99646 -.084037 .33766 .94127 0 0)",
    x: -656.77,
    y: 2209.7,
    width: 25.071,
    height: 75.636,
    strokeWidth: 15.728
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99963 -.027042 .2547 .96702 0 0)",
    x: -801.6,
    y: 2119,
    width: 17.839,
    height: 71.852,
    strokeWidth: 15.311
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99643 -.084405 .29318 .95606 0 0)",
    x: -843.89,
    y: 2103.5,
    width: 24.962,
    height: 74.466,
    strokeWidth: 15.572
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99638 -.084969 .27625 .96109 0 0)",
    x: -855.89,
    y: 2088,
    width: 24.796,
    height: 74.076,
    strokeWidth: 15.52
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99643 -.084405 .29318 .95606 0 0)",
    x: -787.18,
    y: 2103.1,
    width: 24.962,
    height: 74.466,
    strokeWidth: 15.572
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99641 -.084651 .26242 .96495 0 0)",
    x: -829.5,
    y: 2075.5,
    width: 24.889,
    height: 73.78,
    strokeWidth: 15.477
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99951 -.031391 .3065 .95187 0 0)",
    x: -812.99,
    y: 2161.4,
    width: 14.497,
    height: 68.861,
    strokeWidth: 15.457
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99644 -.084281 .30823 .95131 0 0)",
    x: -820.1,
    y: 2050.2,
    width: 24.998,
    height: 74.837,
    strokeWidth: 15.622
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99638 -.084969 .27625 .96109 0 0)",
    x: -865.43,
    y: 2021.8,
    width: 24.796,
    height: 74.076,
    strokeWidth: 15.52
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99642 -.084527 .2779 .96061 0 0)",
    x: -833.24,
    y: 2023.5,
    width: 24.925,
    height: 74.113,
    strokeWidth: 15.524
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.9964 -.084776 .24672 .96909 0 0)",
    x: -874.67,
    y: 1999.4,
    width: 24.853,
    height: 73.464,
    strokeWidth: 15.433
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99639 -.0849 .23082 .973 0 0)",
    x: -881.89,
    y: 1988.5,
    width: 24.816,
    height: 73.168,
    strokeWidth: 15.391
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99659 -.082549 .29858 .95438 0 0)",
    x: -830.71,
    y: 1973.9,
    width: 24.971,
    height: 72.983,
    strokeWidth: 15.584
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99571 -.092486 .25545 .96682 0 0)",
    x: -898.52,
    y: 1931.6,
    width: 22.781,
    height: 73.637,
    strokeWidth: 15.479
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99581 -.091444 .22958 .97329 0 0)",
    x: -924.99,
    y: 1914.4,
    width: 23.04,
    height: 73.146,
    strokeWidth: 15.404
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99605 -.088793 .22114 .97524 0 0)",
    x: -910.75,
    y: 1911.1,
    width: 23.728,
    height: 72.999,
    strokeWidth: 15.375
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99636 -.085223 .27503 .96143 0 0)",
    x: -868.84,
    y: 1885.4,
    width: 24.348,
    height: 72.928,
    strokeWidth: 15.517
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99543 -.095494 .23236 .97263 0 0)",
    x: -930.98,
    y: 1846.5,
    width: 22.209,
    height: 73.683,
    strokeWidth: 15.422
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99553 -.094417 .20684 .97837 0 0)",
    x: -954.37,
    y: 1831.6,
    width: 22.463,
    height: 73.249,
    strokeWidth: 15.354
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99088 -.13473 .18996 .98179 0 0)",
    x: -974.12,
    y: 1781.6,
    width: 15.234,
    height: 70.643,
    strokeWidth: 15.412
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99939 -.034915 .27651 .96101 0 0)",
    x: -870.12,
    y: 1931.6,
    width: 15.568,
    height: 73.333,
    strokeWidth: 15.383
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99591 -.090369 .21811 .97592 0 0)",
    x: -1001.1,
    y: 1777.7,
    width: 22.81,
    height: 71.37,
    strokeWidth: 15.372
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99588 -.090652 .18551 .98264 0 0)",
    x: -979.99,
    y: 1761,
    width: 22.739,
    height: 70.883,
    strokeWidth: 15.295
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99588 -.090652 .18551 .98264 0 0)",
    x: -1006.8,
    y: 1760.2,
    width: 22.739,
    height: 70.883,
    strokeWidth: 15.295
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.9959 -.09051 .20189 .97941 0 0)",
    x: -1003.9,
    y: 1769.1,
    width: 22.774,
    height: 71.119,
    strokeWidth: 15.332
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99588 -.090652 .18551 .98264 0 0)",
    x: -993.75,
    y: 1698.5,
    width: 22.739,
    height: 70.883,
    strokeWidth: 15.295
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99588 -.090652 .18551 .98264 0 0)",
    x: -1020.6,
    y: 1697.6,
    width: 22.739,
    height: 70.883,
    strokeWidth: 15.295
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.9959 -.09051 .20189 .97941 0 0)",
    x: -1018.8,
    y: 1706.2,
    width: 22.774,
    height: 71.119,
    strokeWidth: 15.332
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99489 -.10098 .15724 .98756 0 0)",
    x: -1115.1,
    y: 1612.4,
    width: 20.413,
    height: 70.53,
    strokeWidth: 15.257
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99427 -.10688 .1062 .99435 0 0)",
    x: -1123.1,
    y: 1586.2,
    width: 19.286,
    height: 70.05,
    strokeWidth: 15.173
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99473 -.10249 .10928 .99401 0 0)",
    x: -1143.8,
    y: 1592.8,
    width: 20.113,
    height: 70.073,
    strokeWidth: 15.171
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.995 -.099841 .12663 .99195 0 0)",
    x: -1140.6,
    y: 1602.1,
    width: 20.646,
    height: 70.219,
    strokeWidth: 15.196
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99427 -.10688 .1062 .99435 0 0)",
    x: -1133.9,
    y: 1529.8,
    width: 19.286,
    height: 70.05,
    strokeWidth: 15.173
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99473 -.10249 .10928 .99401 0 0)",
    x: -1154.7,
    y: 1536.4,
    width: 20.113,
    height: 70.073,
    strokeWidth: 15.171
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.995 -.099841 .12663 .99195 0 0)",
    x: -1152.6,
    y: 1545.6,
    width: 20.646,
    height: 70.219,
    strokeWidth: 15.196
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99353 -.11358 .11025 .9939 0 0)",
    x: -1193.2,
    y: 1465.3,
    width: 18.148,
    height: 70.08,
    strokeWidth: 15.191
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99239 -.12317 .062547 .99804 0 0)",
    x: -1191.4,
    y: 1440.3,
    width: 16.736,
    height: 69.792,
    strokeWidth: 15.131
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.9937 -.1121 .068785 .99763 0 0)",
    x: -1204.1,
    y: 1455.9,
    width: 18.388,
    height: 69.818,
    strokeWidth: 15.124
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99383 -.11088 .083589 .9965 0 0)",
    x: -1207.5,
    y: 1461.3,
    width: 18.591,
    height: 69.897,
    strokeWidth: 15.144
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99239 -.12317 .062547 .99804 0 0)",
    x: -1202.3,
    y: 1383.4,
    width: 16.736,
    height: 69.792,
    strokeWidth: 15.131
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.9937 -.1121 .068785 .99763 0 0)",
    x: -1215.4,
    y: 1399,
    width: 18.388,
    height: 69.818,
    strokeWidth: 15.124
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.99383 -.11088 .083589 .9965 0 0)",
    x: -1219.7,
    y: 1404.3,
    width: 18.591,
    height: 69.897,
    strokeWidth: 15.144
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1338.9 1948h42.014l41.479 110.92h-50.418l-33.075-110.92z",
    fillRule: "evenodd",
    stroke: "#d1e2bd",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "m987.95 1540.9s-10.056 176.45-30.717 404.32c-16.825 185.57-40.065 260.86-40.065 260.86l-229.69 40.743s41.185-102.48 80.111-359.92c17.701-116.45 35.222-289.98 35.222-289.98l185.14-56.011z",
    stroke: "#d1e2bd",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98717 -.15964 -.25337 .96737 0 0)",
    x: 1366.1,
    y: 2460,
    width: 28.745,
    height: 75.26,
    strokeWidth: 15.685
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98707 -.1603 -.22192 .97507 0 0)",
    x: 1411.8,
    y: 2421.6,
    width: 28.608,
    height: 74.61,
    strokeWidth: 15.58
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98771 -.15629 -.2298 .97324 0 0)",
    x: 1342.1,
    y: 2426.4,
    width: 29.461,
    height: 74.764,
    strokeWidth: 15.593
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98707 -.1603 -.22192 .97507 0 0)",
    x: 1367.1,
    y: 2421.3,
    width: 28.608,
    height: 74.61,
    strokeWidth: 15.58
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98696 -.16096 -.1897 .98184 0 0)",
    x: 1370.7,
    y: 2392,
    width: 28.471,
    height: 74.039,
    strokeWidth: 15.484
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98707 -.1603 -.22192 .97507 0 0)",
    x: 1388.1,
    y: 2356.4,
    width: 28.608,
    height: 74.61,
    strokeWidth: 15.58
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98771 -.15629 -.2298 .97324 0 0)",
    x: 1317.9,
    y: 2361.2,
    width: 29.461,
    height: 74.764,
    strokeWidth: 15.593
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98707 -.1603 -.22192 .97507 0 0)",
    x: 1343.4,
    y: 2356.2,
    width: 28.608,
    height: 74.61,
    strokeWidth: 15.58
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98696 -.16096 -.1897 .98184 0 0)",
    x: 1349.3,
    y: 2327.7,
    width: 28.471,
    height: 74.039,
    strokeWidth: 15.484
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98696 -.16096 -.20538 .97868 0 0)",
    x: 1233,
    y: 2290.6,
    width: 28.508,
    height: 74.39,
    strokeWidth: 15.53
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98685 -.16164 -.17287 .98494 0 0)",
    x: 1283.1,
    y: 2258,
    width: 28.372,
    height: 73.864,
    strokeWidth: 15.438
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98751 -.15755 -.18101 .98348 0 0)",
    x: 1213.2,
    y: 2261.9,
    width: 29.225,
    height: 73.988,
    strokeWidth: 15.449
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98685 -.16164 -.17287 .98494 0 0)",
    x: 1238.8,
    y: 2257.8,
    width: 28.372,
    height: 73.864,
    strokeWidth: 15.438
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98674 -.16231 -.13975 .99019 0 0)",
    x: 1247.2,
    y: 2234,
    width: 28.236,
    height: 73.418,
    strokeWidth: 15.354
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98685 -.16164 -.17287 .98494 0 0)",
    x: 1259.7,
    y: 2197.3,
    width: 28.372,
    height: 73.864,
    strokeWidth: 15.438
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98751 -.15755 -.18101 .98348 0 0)",
    x: 1189.3,
    y: 2201.2,
    width: 29.225,
    height: 73.988,
    strokeWidth: 15.449
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98685 -.16164 -.17287 .98494 0 0)",
    x: 1215.4,
    y: 2197.1,
    width: 28.372,
    height: 73.864,
    strokeWidth: 15.438
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98674 -.16231 -.13975 .99019 0 0)",
    x: 1225.9,
    y: 2174,
    width: 28.236,
    height: 73.418,
    strokeWidth: 15.354
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98681 -.16186 -.17251 .98501 0 0)",
    x: 1148.7,
    y: 2142,
    width: 28.351,
    height: 73.913,
    strokeWidth: 15.438
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98663 -.16298 -.12252 .99247 0 0)",
    x: 1164.5,
    y: 2101.8,
    width: 28.137,
    height: 73.301,
    strokeWidth: 15.315
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98737 -.15841 -.1477 .98903 0 0)",
    x: 1131.5,
    y: 2116.5,
    width: 29.066,
    height: 73.572,
    strokeWidth: 15.364
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98663 -.16298 -.12252 .99247 0 0)",
    x: 1119.6,
    y: 2102.5,
    width: 28.137,
    height: 73.301,
    strokeWidth: 15.315
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98651 -.16368 -.088714 .99606 0 0)",
    x: 1129.5,
    y: 2083.4,
    width: 28,
    height: 72.986,
    strokeWidth: 15.245
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98667 -.16276 -.13906 .99028 0 0)",
    x: 1092.3,
    y: 2056.2,
    width: 28.194,
    height: 73.52,
    strokeWidth: 15.354
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98648 -.1639 -.088386 .99609 0 0)",
    x: 1111.9,
    y: 2020.8,
    width: 27.979,
    height: 73.035,
    strokeWidth: 15.245
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98723 -.15927 -.11387 .9935 0 0)",
    x: 1077.4,
    y: 2033.4,
    width: 28.908,
    height: 73.242,
    strokeWidth: 15.288
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98648 -.1639 -.088386 .99609 0 0)",
    x: 1067.3,
    y: 2021.5,
    width: 27.979,
    height: 73.035,
    strokeWidth: 15.245
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98667 -.16276 -.13906 .99028 0 0)",
    x: 1070.8,
    y: 1995.9,
    width: 28.194,
    height: 73.52,
    strokeWidth: 15.354
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98648 -.1639 -.088386 .99609 0 0)",
    x: 1090.7,
    y: 1961.6,
    width: 27.979,
    height: 73.035,
    strokeWidth: 15.245
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98723 -.15927 -.11387 .9935 0 0)",
    x: 1056,
    y: 1973.4,
    width: 28.908,
    height: 73.242,
    strokeWidth: 15.288
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98648 -.1639 -.088386 .99609 0 0)",
    x: 1046,
    y: 1962.3,
    width: 27.979,
    height: 73.035,
    strokeWidth: 15.245
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98644 -.16413 -.071524 .99744 0 0)",
    x: 1096.3,
    y: 1954.3,
    width: 27.922,
    height: 72.885,
    strokeWidth: 15.213
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98667 -.16276 -.13906 .99028 0 0)",
    x: 1090,
    y: 1928.9,
    width: 28.194,
    height: 73.52,
    strokeWidth: 15.354
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98648 -.1639 -.088386 .99609 0 0)",
    x: 1113.4,
    y: 1895.6,
    width: 27.979,
    height: 73.035,
    strokeWidth: 15.245
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98723 -.15927 -.11387 .9935 0 0)",
    x: 1076.9,
    y: 1906.8,
    width: 28.908,
    height: 73.242,
    strokeWidth: 15.288
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98648 -.1639 -.088386 .99609 0 0)",
    x: 1068.7,
    y: 1896.3,
    width: 27.979,
    height: 73.035,
    strokeWidth: 15.245
  }), /*#__PURE__*/React.createElement("path", {
    d: "m877.75 1969-43.334 6.2976-21.066 110.61 44.193-7.5572 20.204-109.35z",
    fillRule: "evenodd",
    stroke: "#d1e2bd",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98252 -.18614 -.13211 .99124 0 0)",
    x: 1096.9,
    y: 1892.6,
    width: 28.29,
    height: 73.668,
    strokeWidth: 15.395
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98231 -.18726 -.081553 .99667 0 0)",
    x: 1122.5,
    y: 1858.2,
    width: 28.075,
    height: 73.118,
    strokeWidth: 15.279
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98317 -.18269 -.10699 .99426 0 0)",
    x: 1084.7,
    y: 1869.9,
    width: 29.005,
    height: 73.357,
    strokeWidth: 15.325
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98231 -.18726 -.081553 .99667 0 0)",
    x: 1077.7,
    y: 1858.9,
    width: 28.075,
    height: 73.118,
    strokeWidth: 15.279
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98252 -.18614 -.13211 .99124 0 0)",
    x: 1059.8,
    y: 1893.3,
    width: 28.29,
    height: 73.668,
    strokeWidth: 15.395
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.96667 -.25604 -.14122 .98998 0 0)",
    x: 1123.2,
    y: 1935.9,
    width: 28.915,
    height: 74.304,
    strokeWidth: 15.632
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.96638 -.2571 -.091362 .99582 0 0)",
    x: 1148.1,
    y: 1892.4,
    width: 28.698,
    height: 73.427,
    strokeWidth: 15.481
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.96752 -.25279 -.11651 .99319 0 0)",
    x: 1109.8,
    y: 1908.6,
    width: 29.638,
    height: 73.83,
    strokeWidth: 15.542
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.96638 -.2571 -.091362 .99582 0 0)",
    x: 1102.3,
    y: 1893.1,
    width: 28.698,
    height: 73.427,
    strokeWidth: 15.481
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.96632 -.25734 -.12681 .99193 0 0)",
    x: 1113.7,
    y: 1889.5,
    width: 28.635,
    height: 62.471,
    strokeWidth: 15.589
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.96608 -.25824 -.067482 .99772 0 0)",
    x: 1121.8,
    y: 1844.5,
    width: 28.417,
    height: 61.58,
    strokeWidth: 15.418
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.96706 -.25456 -.097437 .99524 0 0)",
    x: 1092.6,
    y: 1862.7,
    width: 29.358,
    height: 61.988,
    strokeWidth: 15.491
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.96608 -.25824 -.067482 .99772 0 0)",
    x: 1076.5,
    y: 1845.1,
    width: 28.417,
    height: 61.58,
    strokeWidth: 15.418
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.95706 -.28991 -.097216 .99526 0 0)",
    x: 1032.9,
    y: 1903.1,
    width: 21.936,
    height: 61.518,
    strokeWidth: 15.602
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeMiterlimit: 3.9101
  }, /*#__PURE__*/React.createElement("path", {
    d: "m880.35 2147.1-335.68 63.23-1.5105 31.242 336.99-64.557 0.20887-29.914z",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "m879.52 2152.1-331.54 62.396-0.68096 21.231 331.71-63.97 0.5107-19.659z",
    stroke: "#d1e2bd",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "m542.28 2117.6c7.4867-1.7184 337.66-69.05 337.66-69.05l-0.21151-38.544-334.94 66.521-2.5094 41.077z",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#d1e2bd",
    strokeWidth: 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "m546.96 2108.8c0.44755-0.3363 330.03-66.692 330.03-66.692l-0.21151-23.798-329.07 66.521-0.74958 23.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m562.94 2106.2 13.133-2.4875 0.47718 104.09-13.663 2.6551 0.0524-104.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m835.11 2054.4 13.133-2.4874 0.47718 104.92-12.833 1.8209-0.77728-104.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m767.47 2066.9 13.133-2.4875-0.35251 104.92-13.662 2.6551 0.88183-105.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m631.41 2093.1 13.133-2.4875-0.35251 104.09-12.833 3.4894 0.0524-105.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m699.42 2080.5 13.133-2.4874 0.47718 104.92-13.663 2.6552 0.0524-105.09z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1335 2230.6 74.042-51.818 240.84 30.474-132.18 39.333-182.7-17.986z",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1341.5 2226.9 62.739-44.246 236.13 30.313-114.35 31.872-184.52-17.938z",
    stroke: "#d1e2bd",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 15
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1370.1 2204.5 99.954 10.993 115.28 14.574-125.82-13.899-89.405-11.668z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1400 2194.4 99.954 10.993 115.28 14.574-125.82-13.899-89.405-11.668z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1341.9 2214.5 99.954 10.993 115.28 14.574-125.82-13.899-89.405-11.668z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#d1e2bd",
    strokeWidth: 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "m543.94 2246.7 141.76 27.467v30.083l-141.76-57.516z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m941.39 2223.7-60.367-40.929 511.79 1e-4c-53.212 40.352-33.763 23.662-58.908 42.847l-392.51-1.9155z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m934.6 2217c282.34-0.9249 281.86-3.9219 281.41-2.072-0.4598 1.8498 278.66 0.4624-0.4598 1.8498-279.12 1.3873-276.16 3.0006-277.77 2.013-3.1004-1.9038-2.8252-1.9179-3.1738-1.7908z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1375.2 2192.9c-282.34-0.9248-282.8-2.7746-282.34-0.9248 0.4599 1.8497-278.66 0.4624 0.4599 1.8497s276.65 2.4322 279.12 1.3873c4.2376-1.7957 2.4104-2.4393 2.7589-2.3122z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m938.91 2222.7-64.477-42.184-339.5 63.954 146.06 27.215 257.91-48.986z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m937.55 2223.7-63.73-40.546-335.56 61.475 144.37 26.159 254.92-47.086z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m657.51 2264.1 214.81-41.717s103.59-21.781-0.34648 0.3693-14.898 5.9067-103.94 22.15c-89.041 16.243-109.48 19.197-110.52 19.197z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m897.93 2205.7-214.81 41.718s-103.59 21.781 0.34647-0.3693 71.723-16.335 160.76-32.578c89.039-16.243 52.657-8.7686 53.698-8.7686z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m573.32 2249.5 5.392 1.2514 306.52-57.983-2.0739-0.8343-309.84 57.562z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1638.3 2188.6-240.54-35.672 0.03 22.417 240.53 33.035-0.026-19.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1397.8 2040.1c240.88 35.107 240.47 34.842 240.47 34.842l-0.039-28.906-239.62-31.514-0.8032 25.578z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1413.1 2044.2 16.3 1.4416-1.1648 110.43-14.882-0.9108-0.2533-110.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1612.7 2073.7 16.3 1.4416-1.1648 110.43-14.882-0.9108-0.2534-110.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1563.1 2066 16.3 1.4415-1.1649 110.43-14.882-0.9108-0.2537-110.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1463.3 2051.6 16.3 1.4415-1.1649 110.43-14.882-0.9108-0.2533-110.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1513.2 2059.3 17.633 1.4415-1.2601 110.43-16.099-0.9108-0.2741-110.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2068.5 879.49c-241.44 175.97-454.83 349.51-689.36 534.06l-87.474-105.74-81.212 64.73-23.776-32.809 814.79-648.12 20.49 23.619-704.94 570.64 70.456 88.665 667.83-511.6 13.187 16.564z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m2047.9 868.26-662.06 500.34-66.807-78.362 645.15-523.06 83.702 101.1z",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#d1e2bd",
    strokeWidth: 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2027.6 868.52-27.511 20.375-69.768-85.881 26.7-21.374 70.579 86.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1897.9 969.36-27.511 20.375-68.284-84.055 26.7-21.374 69.095 85.053z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1940.6 934.89-25.746 20.611-69.91-84.119 26.535-21.242 68.95 84.874z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1985.9 901.93-28.463 21.138-69.768-85.881 26.7-21.374 71.533 86.116z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1766.9 1068.6-26.7 21.374-66.325-81.643 26.811-21.463 66.316 81.632z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1811.3 1036.3-28.463 21.138-66.183-83.405 26.7-21.374 67.948 83.641z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1854.5 1002.9-27.511 20.375-67.71-83.348 26.7-21.374 68.521 84.347z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1636.7 1168.9-23.981 20.846-67.085-78.704 26.7-21.374 64.368 79.235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1680 1135.8-26.7 21.374-65.178-80.231 26.812-21.464 65.187 80.242z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1725.6 1102.6-25.746 20.61-68.707-80.701 26.7-21.374 67.639 81.576z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1507.6 1268.9-27.652 22.136-62.746-77.238 26.7-21.374 63.699 76.474z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1550.2 1234.8-26.84 23.135-63.557-78.236 26.7-21.374 63.7 76.474z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1593 1202.2-24.935 21.609-65.322-78.472 26.7-21.374 63.557 78.236z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1418.7 1335.1-26.7 21.374-60.312-74.241 26.811-21.464 60.319 74.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1461.2 1301.1-26.7 21.374-60.312-74.241 26.811-21.464 60.319 74.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m622.49 409.28c195.73 262.17 387.41 494.87 591.71 750.32l-104.95 85.755 71.586 88.488-32.747 23.087-716.86-887.72 23.39-20.15 630.48 768.57 88.158-68.88-567.2-726.53 16.468-12.894z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m611.95 430.15 555.2 719.88-77.667 65.624-577.87-703.38 100.34-82.06z",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#d1e2bd",
    strokeWidth: 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "m613.33 451.41 22.64 29.891-85.307 68.312-23.631-29.097 86.299-69.107z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m725.03 592.63 22.639 29.891-83.493 66.859-23.631-29.097 84.485-67.654z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m686.94 546.08 22.787 28.058-83.471 68.557-23.486-28.918 84.307-67.511z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m650.27 496.9 23.482 30.929-85.307 68.312-23.631-29.097 85.455-70.146z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m835.16 735.12 23.631 29.097-81.098 64.941-23.731-29.219 81.086-64.932z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m799.22 686.84 23.482 30.929-82.934 64.696-23.631-29.097 83.082-66.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m762.24 639.9 22.64 29.891-82.791 66.297-23.631-29.097 83.783-67.092z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m946.28 876.8 22.935 26.224-78.006 65.896-23.631-29.097 78.705-63.026z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m909.59 829.63 23.631 29.097-79.694 63.818-23.731-29.219 79.706-63.827z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m872.67 780.14 22.787 28.058-79.99 67.485-23.631-29.097 80.956-66.319z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1057.1 1017.3 24.474 30.134-76.721 61.437-23.631-29.097 75.877-62.476z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1019.4 970.86 25.466 29.34-77.713 62.231-23.631-29.097 75.877-62.476z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m983.2 924.29 23.779 27.263-77.861 64.065-23.631-29.097 77.713-62.231z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1130.7 1113.9 23.631 29.097-73.745 59.054-23.73-29.219 73.754-59.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1093 1067.5 23.631 29.097-73.745 59.054-23.731-29.219 73.754-59.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.54 1854.5c241.44-175.9 454.83-349.5 689.36-534l87.474 105.74 81.212-64.73 23.776 32.809-814.79 648.12-20.49-23.618 704.94-570.64-70.456-88.665-667.83 511.6-13.187-16.564z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m314.07 1865.8 662.06-500.34 66.807 78.362-645.15 523.06-83.702-101.1z",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#d1e2bd",
    strokeWidth: 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "m334.39 1865.5 27.511-20.375 69.768 85.881-26.7 21.374-70.579-86.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m464.12 1764.7 27.511-20.375 68.284 84.055-26.699 21.374-69.095-85.053z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.42 1799.1 25.746-20.61 69.91 84.119-26.535 21.242-68.949-84.874z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.12 1832.1 28.463-21.138 69.768 85.881-26.699 21.374-71.533-86.116z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m595.15 1665.4 26.699-21.374 66.325 81.643-26.811 21.464-66.316-81.632z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m550.68 1697.7 28.463-21.138 66.183 83.405-26.7 21.374-67.948-83.641z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m507.55 1731.1 27.511-20.375 67.71 83.348-26.699 21.374-68.521-84.347z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m725.35 1565.1 23.981-20.846 67.085 78.704-26.699 21.374-64.368-79.235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m681.99 1598.2 26.699-21.374 65.177 80.231-26.811 21.464-65.187-80.242z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m636.41 1631.4 25.746-20.61 68.707 80.701-26.699 21.374-67.639-81.576z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m854.4 1465.1 27.652-22.136 62.746 77.238-26.7 21.374-63.699-76.474z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m811.83 1499.2 26.84-23.135 63.557 78.236-26.699 21.374-63.699-76.474z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m769.02 1531.9 24.935-21.609 65.322 78.472-26.699 21.374-63.557-78.236z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m943.36 1398.9 26.699-21.374 60.312 74.241-26.811 21.464-60.319-74.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m900.79 1433 26.7-21.374 60.312 74.241-26.811 21.464-60.319-74.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1735.7 2324.6c-195.73-262.17-387.42-494.87-591.68-750.28l104.95-85.755-71.586-88.488 32.747-23.087 716.86 887.72-23.39 20.15-630.48-768.57-88.158 68.88 567.2 726.53-16.468 12.894z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1746.3 2303.7-555.2-719.88 77.667-65.624 577.86 703.43-100.34 82.061z",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#d1e2bd",
    strokeWidth: 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1744.9 2282.4-22.64-29.891 85.307-68.312 23.631 29.097-86.299 69.106z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1633.2 2141.2-22.64-29.891 83.493-66.859 23.632 29.097-84.485 67.654z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1671.3 2187.8-22.787-28.058 83.471-68.557 23.486 28.918-84.307 67.511z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1708 2236.9-23.482-30.929 85.307-68.312 23.631 29.097-85.455 70.146z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1523.1 1998.7-23.631-29.097 81.098-64.941 23.731 29.219-81.086 64.932z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1559 2047-23.482-30.929 82.934-64.696 23.632 29.097-83.082 66.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1596 2093.9-22.64-29.891 82.791-66.297 23.631 29.097-83.783 67.092z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1411.9 1857-22.935-26.224 78.006-65.896 23.632 29.097-78.705 63.026z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1448.6 1904.2-23.631-29.097 79.694-63.818 23.731 29.219-79.706 63.827z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1485.6 1953.7-22.787-28.058 79.99-67.485 23.632 29.097-80.956 66.319z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1301.2 1716.6-24.474-30.134 76.721-61.437 23.631 29.097-75.877 62.476z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1338.8 1763-25.466-29.34 77.713-62.231 23.632 29.097-75.877 62.476z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1375 1809.6-23.779-27.263 77.861-64.065 23.631 29.097-77.713 62.231z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1227.6 1619.9-23.631-29.097 73.745-59.054 23.73 29.219-73.754 59.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1265.2 1666.3-23.631-29.097 73.745-59.054 23.731 29.219-73.754 59.06z"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-.011928 -.99993 .99918 .040477 0 0)",
    cx: -1322.3,
    cy: 1163.3,
    rx: 56.83,
    ry: 58.022,
    stroke: "#d1e2bd",
    strokeMiterlimit: 3.9101,
    strokeWidth: 9.0062
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeMiterlimit: 3.9101
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 15
  }, /*#__PURE__*/React.createElement("path", {
    d: "m874.55 2007.9c523.26-2.3038 519.71-1.1519 519.71-1.1519v48.379l-518.54-1.1519-1.1732-46.078z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m876.2 2145.8c523.26-1.7643 519.71-0.8822 519.71-0.8822v37.054l-518.54-0.8822-1.1732-35.289z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m894.83 2052.9c38.127 0 38.127 0.5899 38.127 0s-1.7598 90.847-1.7598 90.847h-36.369v-90.843z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1212.2 2053.5c38.127 0 38.127 0.5899 38.127 0s-1.7597 90.847-1.7597 90.847h-36.369v-90.843z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1106 2053.5c38.127 0 38.127 0.5899 38.127 0s-1.7598 90.847-1.7598 90.847h-36.369v-90.843z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1004.5 2052.9c38.127 0 38.127 0.5899 38.127 0s-1.7597 90.847-1.7597 90.847h-36.369v-90.843z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1317.8 2054.1c38.127 0 38.127 0.59 38.127 0 0-0.5899-1.7598 90.847-1.7598 90.847h-36.368v-90.843z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#d1e2bd",
    strokeWidth: 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1393.1 2153.5-513.07-1.9365-0.68506 21.867 513.7-0.6412 0.031-19.294z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m879.97 2044.3c511.83 1.3311 510.96 1.1327 510.96 1.1327l0.045-28.196-509.17 2.0017-1.8202 25.064z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m903.98 2044.1 20.474 0.09-1.9518 107.83-18.694 0.3136 0.17216-108.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1328.2 2045.6 20.474 0.09-1.9519 107.83-18.694 0.3136 0.1721-108.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1222.8 2044.9 20.474 0.09-1.9518 107.83-18.694 0.3137 0.1722-108.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1014.2 2044.4 20.474 0.09-1.9518 107.83-18.694 0.3137 0.1722-108.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1116.7 2045.2 20.474 0.09-1.9518 107.83-18.694 0.3137 0.1722-108.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m689.96 2274.9 242.51-45.236v566.03s-152.23 2.6159-241.97 1.308l-0.53871-522.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m899.28 2236.3c3.5879 283.93 6.698 284.38 3.5879 283.93-3.1102-0.4545 1.2313 280.23-3.1102-0.4545-4.3415-280.69-10.536-277.9-4.3417-280.69 6.1939-2.7904 4.08-2.4345 3.8636-2.7844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m867.91 2385.3c2.124 283.93 3.9654 284.38 2.124 283.93-1.8412-0.4545 0.72896 280.23-1.8412-0.4545-2.5702-280.69-6.2369-277.9-2.5702-280.69 3.6669-2.7904 2.4153-2.4345 2.2874-2.7844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m714.77 2276.3c2.49 283.93 4.6486 284.38 2.49 283.93-2.1585-0.4545 0.85454 280.23-2.1585-0.4545-3.013-280.69-7.3118-277.9-3.013-280.69 4.2987-2.7903 2.8314-2.4344 2.6815-2.7844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m825.04 2792c2.124-283.93 3.9654-284.38 2.124-283.93-1.8412 0.4545 0.72895-280.23-1.8412 0.4545-2.5702 280.69-6.2369 277.9-2.5702 280.69 3.6669 2.7904 2.4153 2.4344 2.2874 2.7844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m749.94 2789.6c2.124-283.93 3.9654-284.38 2.124-283.93-1.8412 0.4545 0.72896-280.23-1.8412 0.4545-2.5702 280.69-6.2369 277.9-2.5702 280.69 3.6669 2.7903 2.4153 2.4344 2.2874 2.7844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m789.87 2662.3c3.9537-283.93 7.3812-284.38 3.9537-283.93-3.4274 0.4545 1.3569-280.23-3.4274 0.4545-4.7843 280.69-11.61 277.9-4.7843 280.69 6.8258 2.7903 4.4959 2.4344 4.258 2.7844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m758.8 2389.4 101.53-16.284v225.29l-100.39 6.2415-1.1395-215.25z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m766.83 2399.3 84.583-12.458 0.82958 199.05-85.412 6.7302v-193.32z",
    stroke: "#d1e2bd",
    strokeMiterlimit: 3.9101,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#d1e2bd",
    strokeMiterlimit: 3.9101,
    strokeWidth: 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "m952.36 2229.8 369.97 1.8498v566.03h-367.99l-1.9784-567.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m993.76 2784.6c2.6325-356.44 4.9147-357.01 2.6325-356.44-2.282 0.5706 0.90347-351.8-2.282 0.5706s-7.7303 348.87-3.1855 352.37c4.5445 3.503 2.9935 3.0562 2.835 3.4956z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1290.8 2227.9c2.6325 356.44 4.9147 357.01 2.6325 356.44-2.282-0.5706 0.9035 351.8-2.282-0.5706s-7.7303-348.87-3.1855-352.37c4.5445-3.503 2.9935-3.0562 2.835-3.4955z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1051.3 2257.6c2.1241 283.93 3.9655 284.38 2.1241 283.93-1.8413-0.4545 0.7289 280.23-1.8413-0.4545-2.5702-280.69-6.2369-277.9-2.5702-280.69 3.6669-2.7903 2.4153-2.4344 2.2874-2.7844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1098.8 2795.3c2.1241-283.93 3.9655-284.38 2.1241-283.93-1.8413 0.4545 0.7289-280.23-1.8413 0.4545-2.5702 280.69-6.2369 277.9-2.5702 280.69 3.6669 2.7903 2.4153 2.4344 2.2874 2.7844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1148.4 2789.5c-2.124-283.93-3.9654-284.38-2.124-283.93 1.8412 0.4545-0.729-280.23 1.8412 0.4545 2.5702 280.69 6.2369 277.9 2.5702 280.69-3.6668 2.7904-2.4153 2.4345-2.2874 2.7844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1189.5 2230.4c2.6325 356.44 4.9147 357.01 2.6325 356.44-2.282-0.5706 0.9035 351.8-2.282-0.5706s-7.7303-348.87-3.1855-352.37c4.5445-3.503 2.9935-3.0562 2.835-3.4956z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1255.1 2799.6c2.6325-397.04 4.9147-397.69 2.6325-397.04-2.282 0.6356 0.9035-391.89-2.282 0.6356-3.1855 392.52-7.7303 388.62-3.1855 392.53 4.5445 3.9022 2.9935 3.4044 2.835 3.8939z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1147.6 2638.5c-2.1241-283.93-3.9654-284.38-2.1241-283.93 1.8413 0.4545-0.7289-280.23 1.8413 0.4545 2.5702 280.69 6.2369 277.9 2.5702 280.69-3.6669 2.7904-2.4153 2.4345-2.2874 2.7844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1067.6 2361.9 147.82 1.2359v231.13l-147.82 1.236v-233.6z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#d1e2bd",
    strokeMiterlimit: 3.9101,
    strokeWidth: 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1079.3 2373.7 124.36 0.056v209.9l-124.36 0.056v-210.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1342.2 2233.4 177.48 16.237 1.3006 550.33-176.94 1.308-1.8393-567.88z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1361.2 2248.2 1.1732 534.44"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#d1e2bd",
    strokeMiterlimit: 3.9101,
    strokeWidth: 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1438.3 2246c-1.1732 679.51-7.0392-1.8597-7.0392-1.8597l7.0392 1.8597z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1368.2 2234c1.1732 1247 7.0392 2.711 7.0392 2.711l-7.0501-2.7299z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1498.4 2801.1c0.6274-1232.4 3.7647-2.6791 3.7647-2.6791l-3.7701 2.6919z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1473.2 2795.3c-0.7638-679.51-4.5833-1.4772-4.5833-1.4772l4.5833 1.4772z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1402.2 2796.1c0.6275-1232.4 3.7647-2.6792 3.7647-2.6792l-3.7701 2.692z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1474.8 2244.3c-1.1732 677.65-7.0392-1.8547-7.0392-1.8547l7.0501 1.8578z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1445 2794.4c-0.7639-679.51-4.5834-1.4772-4.5834-1.4772l4.5834 1.4772z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1389.3 2366.2 82.415 7.4631-0.4599 228.44-81.955-2.3035v-233.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1398.9 2378.1 64.273 4.2275-2.4887 207.39-61.785-1.6124v-210.01z",
    stroke: "#d1e2bd",
    strokeMiterlimit: 3.9101,
    strokeWidth: 9
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStampNetherlands);
export default __webpack_public_path__ + "static/media/StampNetherlands.eebf9e7948df16b8412f7d9badf16c62.svg";
export { ForwardRef as ReactComponent };